import { render, staticRenderFns } from "./TagInicio.vue?vue&type=template&id=c71608a4&scoped=true&"
import script from "./TagInicio.vue?vue&type=script&lang=js&"
export * from "./TagInicio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c71608a4",
  null
  
)

export default component.exports